<script setup lang="ts">

import { onMounted } from "vue";
import { useBackButton } from "@app/Components/Utilities";

onMounted( () =>
{
    useBackButton();
} );

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base items-center
                 w-full h-full overflow-y-auto flex flex-col pt-6 px-4 lg:px-6 pb-12">

        <h1 class="text-lg lg:text-xl mb-6 lg:mb-4">Coming Soon!</h1>
        <img src="/images/early-access/early-access.png" class="w-1/2 opacity-70 mb-4" />
        <h2 class="text-lg">Carbucks is in Early Access mode</h2>
        <h2 class="opacity-60">So some features are not yet available!</h2>

        <p class="mt-6 mb-2 text-justify">
            This means that you are part of a test group, with early access to the Carbucks App 
            prior to it's official launch.
        </p>
    
        <p class="mb-2 text-justify">
            Once the app leaves Early Access mode, you will automatically have access to the full range
            of features, so check back regularly.
        </p>
        
        <p class="mb-6 text-justify">
            Thanks for participating and we really do appreciate your feedback, so if you find 
            anything you think we could do better, please send a message to our support team!
        </p>

        <JupiterButton type="url"
                       to="https://support.carbucks.com.au/help"
                       size="large"
                       class="uppercase text-orange-500 text-lg">
           Contact support
        </JupiterButton>

    </div>
    
</template>